export default __webpack_public_path__ + "static/media/video_movie_line.bbfd62a2.svg";